//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as paymentTicketAction from '../action/paymentTicketAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';
//Add
import moment from 'moment';
//Icon
import CloseIcon from '@material-ui/icons/Close';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errorComment: null,
      paymentTicketList: [],
      paymentTicketId: null,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      this.props.paymentTicketSendCheck(this.props.pic, (data) => {
        if (data.bool) {
          this.setState({paymentTicketList: data.list});
        }
        else {
          this.setState({errorComment: data.comment});
        }
      });
    }
  }



  _submit() {
    this.props.paymentTicketSend(this.props.pic, this.state.paymentTicketId, () => {
      this.setState({paymentTicketId: null});
      this.props.onClose();
    });
  }



  _renderList(value, index, arr) {

    let backgroundColor;
    let textColor;
    let border;

    if (this.state.paymentTicketId === value.payment_ticket_id) {
      border = '1px solid #CD4695';
      backgroundColor = '#E7B0D0';
      textColor = '#5D0036';

    }
    else {
      border = '1px solid #999';
      backgroundColor = '#FFF';
      textColor = '#333';
    }

    return (
      <div key={index}>
        <div
          className='round12'
          style={{
            color: textColor,
            backgroundColor: backgroundColor,
            border: border,
            margin: '10px',
            cursor: 'pointer',
          }}
          onClick={ () => this.setState({paymentTicketId: value.payment_ticket_id}) }
        >
          <div style={{padding:'10px'}}>
            <div>
              有料サービス {value.payment_ticket_day}日
            </div>
            <div>
                <span>未使用 利用期限 {moment(value.payment_ticket_expire).format("YYYY年MM月DD日")}</span>
            </div>
          </div>
        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    );
  }


	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
        onClose={ () => this.props.onClose() }
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            応援チケットをプレゼント
          </div>
          <IconButton
            onClick={ () => {
              this.props.onClose();
              this.setState({paymentTicketId: null});
            }}
          >
            <CloseIcon/>
          </IconButton>
        </div>

        {
          (this.state.errorComment) && (
            <div style={{padding:'10px'}}>{this.state.errorComment}</div>
          )
        }
        {
          (this.state.paymentTicketList.length > 0) && (
            <div>
              <div style={{padding:'10px'}}>
                渡すチケットを選択してください
              </div>
              <div>
                {
                  this.state.paymentTicketList.map(
                    (value, index, arr) => this._renderList(value, index, arr)
                  )
                }
              </div>
            </div>
          )
        }
        <div>
          <DialogActions>
            <Button
              variant="contained"
              color='primary'
              size="large"
              onClick={ () => this._submit() }
              disabled={(this.state.paymentTicketId) ? false: true }
            >
              有料サービスをプレゼントする
            </Button>
          </DialogActions>
        </div>

			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...paymentTicketAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
